module.exports = __webpack_public_path__ + "static/media/monkey-transparent2.9eb4874b.gif";